import { useStoryblokApi } from '@storyblok/nuxt-2';
import type { ISbStoryData, ISbRichtext } from '@storyblok/js/dist/types';

export function renderRichText(richText: ISbStoryData): ISbRichtext | null {
  if (!richText) return null;

  const storyblokApi = useStoryblokApi();
  return storyblokApi.richTextResolver.render(richText);
}
